import api from './api';

export const getAccounts = async (status) => {
  const params = status ? { status } : {};
  const response = await api.get('/auth/admin/accounts', { params });
  return response.data;
};

export const approveAccount = async (accountId) => {
  const response = await api.post(`/auth/admin/accounts/${accountId}/approve`);
  return response.data;
};

export const waitlistAccount = async (accountId) => {
  const response = await api.post(`/auth/admin/accounts/${accountId}/waitlist`);
  return response.data;
};

export const suspendAccount = async (accountId) => {
  const response = await api.post(`/auth/admin/accounts/${accountId}/suspend`);
  return response.data;
};

export const updateSubscription = async (accountId, data) => {
  const response = await api.put(`/auth/admin/accounts/${accountId}/subscription`, data);
  return response.data;
};
